export let en_lang = {
  "leaf.application-changer.applications" : "Applications",
  "leaf.common.signout" : "Sign out",
  "leaf.common.options" : "Options"
}
